export const PUSH_DATA = 'PUSH_DATA'

export const GET_DASHBOARD_DATA = 'GET_DASHBOARD_DATA';
export const GET_DASHBOARD_ATTENDANCE_SUMMARY = 'GET_DASHBOARD_ATTENDANCE_SUMMARY'
export const GET_DASHBOARD_CALENDAR_DATA_ALL = 'GET_DASHBOARD_CALENDAR_DATA_ALL'


export const GET_TODAY_ATTENDANCE_TIME = 'GET_TODAY_ATTENDANCE_TIME';
export const GET_LEAVE_DATA = 'GET_LEAVE_DATA'
export const EDIT_LEAVE_DATA = 'EDIT_LEAVE_DATA'
export const GET_EMPLOYEE_DATA = 'GET_EMPLOYEE_DATA'
export const EMPLOYEE_LEAVE_COUNT = 'EMPLOYEE_LEAVE_COUNT'
export const GET_EMPLOYEE_ID = 'GET_EMPLOYEE_ID'
export const GET_USER = 'GET_USER';
export const GET_EMPLOYEE_ATTENDANCE = 'GET_EMPLOYEE_ATTENDANCE'
export const INSERT_IN_OUT_TIME = 'INSERT_IN_OUT_TIME'
export const INSERT_EMPLOYEE_ATTENDANCE = 'INSERT_EMPLOYEE_ATTENDANCE'
export const DELETE_EMPLOYEE_ATTENDANCE = 'DELETE_EMPLOYEE_ATTENDANCE'
export const GET_EMP_LEAVES = 'GET_EMP_LEAVES'
export const GET_BINDING_LEAVE_RECORDS = 'GET_BINDING_LEAVE_RECORDS'
export const GET_HOLIDAY = 'GET_HOLIDAY'
export const GET_BIND_WORKLOG = 'GET_BIND_WORKLOG'
export const GET_ALL_PROJECTS = 'GET_ALL_PROJECTS'
export const GET_ALL_TASKS = 'GET_ALL_TASKS'
export const GET_INSERT_WORKLOG = 'GET_INSERT_WORKLOG'
export const GET_TAXSAVING_RECEIPT = 'GET_TAXSAVING_RECEIPT'
export const GET_TAXSAVING_TYPES = 'GET_TAXSAVING_TYPES'
export const GET_ADMIN_USERS = 'GET_ADMIN_USERS'
export const UPDATE_USER = 'UPDATE_USER'
export const GET_ATTENDANCE_REPORT = 'GET_ATTENDANCE_REPORT'
export const GET_LEAVE_REPORT = 'GET_LEAVE_REPORT'
export const GET_ALLTAXSAVING_TYPES = 'GET_ALLTAXSAVING_TYPES'
export const GET_MAP_EMPLOYEE = 'GET_MAP_EMPLOYEE'
export const GET_CONTAINERS = 'GET_CONTAINERS'
export const GET_USER_CONTAINER_PERMISSION='GET_USER_CONTAINER_PERMISSION'

export const SAVE_TAXSAVING_RECEIPT = 'SAVE_TAXSAVING_RECEIPT'
export const GET_TAXSAVING_REPORT = 'GET_TAXSAVING_REPORT'
export const GET_TAXSAVING_RECORDS = 'GET_TAXSAVING_RECORDS'


